import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData } from '../../dto/data-model-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { MarketingVendorSettings } from '../business-level-marketing/marketing-vendor-settings.js';

export class PartnerAppNewsletterSettings extends DataModel {
  static readonly TYPE_ID: string = 'dc30212d0fb74cb19f9ddc8403c4a817';

  private constructor(
    public readonly vendorSettings: MarketingVendorSettings | null,
  ) {super();}

  get $typeId(): string {
    return PartnerAppNewsletterSettings.TYPE_ID;
  }

  static create(args: {
    vendorSettings: MarketingVendorSettings | null,
  }): PartnerAppNewsletterSettings {
    return new PartnerAppNewsletterSettings(
        args.vendorSettings,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): PartnerAppNewsletterSettings {
    return PartnerAppNewsletterSettings.create({
      vendorSettings: context.fromDataOrNull(MapUtils.getRecordOrNull(map, 'vendorSettings')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      vendorSettings: context.toDataOrNull(this.vendorSettings),
    };
  }

  clone(): this {
    return PartnerAppNewsletterSettings.create({
      vendorSettings: this.vendorSettings?.clone() ?? null,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.vendorSettings, this.vendorSettings);
  }
}

export class PartnerAppNewsletterSettingsBuilder extends DataModelBuilder<PartnerAppNewsletterSettings> {
  build(context: SerializationContext, map: SerializedData): PartnerAppNewsletterSettings {
    return PartnerAppNewsletterSettings.fromMap(context, map);
  }
}
